<div
  *ngIf="isAlertVisible"
  class="mx-auto max-w-prose rounded-xl bg-warning py-6 px-4 text-center text-sm text-apricot-1"
>
  <p>Det här är den närmaste veckan med lediga tider.</p>
</div>
